import React, { Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flame, TrendingUp } from 'lucide-react';
import { useCountdown } from '../../hooks/useCountdown';
export function ScarcityCountdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23, 47, 22);
  const units = [{
    label: 'Horas',
    value: hours
  }, {
    label: 'Min',
    value: minutes
  }, {
    label: 'Seg',
    value: seconds
  }];
  return <section className="pt-8 md:pt-12 px-4 md:px-8 max-w-3xl mx-auto" data-id="element-245">
      <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-offwhite border-2 border-terracotta/30 rounded-2xl p-4 md:p-6" data-id="element-246">
        {/* Top row */}
        <div className="flex items-center justify-between gap-2 mb-4 md:mb-5" data-id="element-247">
          <span className="flex items-center gap-2 font-sans font-bold uppercase tracking-wider text-[11px] md:text-sm text-terracotta" data-id="element-248">
            <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse" data-id="element-249" />
            Oferta en vivo
          </span>
          <span className="flex items-center gap-1 bg-terracotta/10 text-terracotta font-sans font-bold text-[10px] md:text-xs px-2.5 py-1 rounded-full" data-id="element-250">
            <TrendingUp size={13} data-id="element-251" /> Sube después
          </span>
        </div>

        {/* Middle row */}
        <div className="flex items-center justify-between gap-3 md:gap-4 flex-wrap mb-5 md:mb-6" data-id="element-252">
          <div className="flex items-start gap-2.5" data-id="element-253">
            <Flame size={20} className="text-terracotta shrink-0 mt-0.5" data-id="element-254" />
            <div data-id="element-255">
              <p className="font-serif font-bold text-base md:text-xl text-brown leading-tight" data-id="element-256">
                LANZAMIENTO <span className="text-terracotta" data-id="element-257">TERMINA EN</span>
              </p>
              <p className="font-sans text-xs md:text-sm text-brown/60" data-id="element-258">
                Y no vuelve a bajar
              </p>
            </div>
          </div>

          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-259">
            {units.map((unit, i) => <Fragment key={unit.label} data-id="element-260">
                <div className="flex flex-col items-center" data-id="element-261">
                  <div className="bg-terracotta text-offwhite font-serif font-bold text-xl md:text-3xl w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-xl shadow-sm overflow-hidden relative" data-id="element-262">
                    <AnimatePresence mode="popLayout" data-id="element-263">
                      <motion.span key={unit.value} initial={{
                    y: 16,
                    opacity: 0
                  }} animate={{
                    y: 0,
                    opacity: 1
                  }} exit={{
                    y: -16,
                    opacity: 0
                  }} transition={{
                    duration: 0.2
                  }} className="absolute" data-id="element-264">
                        {unit.value.toString().padStart(2, '0')}
                      </motion.span>
                    </AnimatePresence>
                  </div>
                  <span className="font-sans text-[9px] md:text-[11px] text-brown/60 mt-1.5 uppercase tracking-wider" data-id="element-265">
                    {unit.label}
                  </span>
                </div>
                {i < units.length - 1 && <span className="font-serif font-bold text-lg md:text-2xl text-terracotta/50 pb-4 md:pb-5" data-id="element-266">
                    :
                  </span>}
              </Fragment>)}
          </div>
        </div>

        {/* Progress row */}
        <div data-id="element-267">
          <div className="flex justify-between font-sans text-[11px] md:text-sm font-bold mb-2" data-id="element-268">
            <span className="text-brown/70 uppercase tracking-wider" data-id="element-269">
              Cupos restantes
            </span>
            <span className="text-terracotta" data-id="element-270">68% TOMADOS</span>
          </div>
          <div className="h-2.5 md:h-3 bg-cream rounded-full overflow-hidden border border-brown/10" data-id="element-271">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.2
          }} className="h-full bg-terracotta rounded-full" data-id="element-272" />
          </div>
        </div>
      </motion.div>
    </section>;
}